import React, {Fragment} from "react";
import {Form, InputGroup, Button} from "react-bootstrap";
import ModalBase from "./ModalBase";
import Participants from "../general/participants/Participants.js";
import SVG from "react-inlinesvg";

import "../../../assets/sass/components/modals/participants-modal.scss";

import searchIcon from "../../../assets/svg/actions/icn-search.svg";
import closeIcon from "../../../assets/svg/actions/icn-close.svg";

import classes from "classnames";

class ParticipantsModal extends ModalBase {

    state = {
        participants: []
    };

    extraClassName = null;

    titles = {};

    toggleSelected = (index, active) => {

        var participants = this.state.participants.map((item) => {
            if(item.key == index)
                item.selected = active
            return item;
        });

        this.setState({
            participants: participants
        })
    }

    insertHeading = () => {
        return (
            <Fragment>
                <div className="d-flex justify-content-between align-items-center">
                    <h2>{this.titles.heading}</h2>
                    <Button variant="link" className="close-modal" onClick={this.closeModal}><SVG src={closeIcon}/></Button>
                </div>
                <p>{this.titles.sub_heading}</p>
            </Fragment>
        )
    }

    insertContent = () => {
        return (
            <InputGroup className="input-group-flat-lg mt-3 mb-3">
                <Form.Control name="text" placeholder="Search Participants" className="input input-flat input-lg"/>
                <InputGroup.Append>
                    <InputGroup.Text>
                        <i><SVG src={searchIcon}/></i>
                    </InputGroup.Text>
                </InputGroup.Append>
            </InputGroup>
        )
    }

    insertParticipants = () => {
        return (
            <Participants data={this.state.participants} itemToggleSelected={this.toggleSelected} activeIcon={this.activeIcon()} inactiveIcon={this.inactiveIcon()}/>
        )
    }

    activeIcon  = () => {
        return null;
    }

    inactiveIcon = () => {
        return null
    }

    renderHeaderWrapper = () => {}
    renderBody = () => {
        return (
            <Fragment>
                {this.insertHeading()}
                {this.insertContent()}
                {this.insertParticipants()}
            </Fragment>
        )
    };

    onSubmit = (event) => { event.preventDefault(); }

    renderFooter = () => {
        return (
            <Button variant="primary" className="btn-block btn-lg" onClick={this.onSubmit}>{this.titles.submit}</Button>
        );
    }

    static defaultProps = {
        className: classes("participants-modal", this.extraClassName),
        size: "md"
    };
};

export default ParticipantsModal;